// extracted by mini-css-extract-plugin
export default {"border":"SuccessBorder_border__18M7X","icon":"SuccessBorder_icon__pZvlq","iconWrap":"SuccessBorder_iconWrap__3o90K","container":"SuccessBorder_container__Sr5+9"};